<app-header></app-header>

<section class="container-xxl">
    <!-- BREADCRUMB AREA - STARTS -->
    <div class="breadcrumb-area">
        
        <app-plugin-breadcrumb [datacollection]="{data:P_data,'showEmpMen':showEmpMen,'emp_dtl':emp_dtl}" *ngIf="showBarComponent"></app-plugin-breadcrumb>
    </div>
    <!-- BREADCRUMB AREA - ENDS -->

    <div class="inner-page">
        <div class="inner-page-details"> 
            <div class="row">
                <div [ngClass]="navMenu ? 'col-xl-3 col-xxl-2' : ''" *ngIf="navMenu">
                    <div [style]="navmenuloadCss">
                        <app-plugin-navbar [datacollection]="{data:P_data}" *ngIf="showNavComponent"></app-plugin-navbar>
                      </div>
                </div>
                <div [ngClass]="navMenu ? 'col-xl-9 col-xxl-10' : 'col-lg-12'">
                    <!-- INNER CONTENT - STARTS -->
                    <div class="inner-page-sidedetails">
                        <div class="row">
                            <div class="col-lg-12">
                                <div id="section-New"></div>
                                <div class="inner-banner-image">
                                    <div class="image-area">
                                        <img class="screen-reader" src="assets/images/inner-banner-2.webp" alt="inner-banner-image">
                                    </div>
                                </div>
                                <div class="details">
                                    <div class="description">
                                        <div class="recruitment">
                                            <div class="row">
                                                <div class="col-lg-12">

                                                    <!-- Recruitment section area -->

                                                    <div class="title">
                                                        <h2 class="screen-reader">{{ 'Recruitments' | translate }}</h2>
                                                    </div>


   <!-- search section -->

   <div class="row">

    <div class="col-xxl-4 col-xl-4 col-md-4 col-sm-4 col-xs-12" ><a style="background-color: yellow;color:red;font-weight: bold;"  title="BEWARE OF FRAUDSTERS" target="_blank" href="assets/public-notice/fake_advt_notice_30012020.pdf" class="btn mb-3"  >BEWARE OF FRAUDSTERS (292.71 KB)<i class="fa fa-pdf-o"></i> </a></div>        
    <div class="col-xxl-4 col-xl-4 col-md-4 col-sm-4 col-xs-12" 
    > <a style="background-color: yellow;color:red;font-weight: bold;"   title="PUBLIC NOTICE- RECRUITMENT FRAUD" target="_blank" href="assets/public-notice/fpci3.pdf" class="btn mb-3"  >PUBLIC NOTICE- RECRUITMENT FRAUD (213.98 KB)<i class="fa fa-pdf-o"></i> </a></div>
    <div class="col-xxl-4 col-xl-4 col-md-4 col-sm-4 col-xs-12" 
    ><a  style="background-color: yellow;color:red;font-weight: bold;"  title="PUBLIC NOTICE- RECRUITMENT FRAUD II" target="_blank" href="assets/public-notice/PUBLIC NOTICE_Cat II - Copy.pdf" class="btn mb-3"  >PUBLIC NOTICE- RECRUITMENT FRAUD II (368.80 KB)<i class="fa fa-pdf-o"></i> </a></div>

   </div>



                                                    <div class="me-lg-0 me-xl-0">
                                                        <ul class="nav nav-pills" id="pills-tab" role="tablist">
                                                            <li class="nav-item" role="presentation">
                                                                <button class="nav-link active screen-reader" [attr.title]="language=='English'?'Current Recruitment':'वर्तमान भर्तियाँ'" id="current-recruitment"
                                                                    data-bs-toggle="pill"
                                                                    data-bs-target="#current-recruitment-tab"
                                                                    type="button" role="tab"
                                                                    aria-controls="pills-current-recruitment"
                                                                    aria-selected="true">{{ 'CurrentRecruitments' | translate }}</button>
                                                            </li>
                                                            <li class="nav-item" role="presentation">
                                                                <button class="nav-link screen-reader" [attr.title]="language=='English'?'Previous Recruitment':'पिछली भर्तियाँ'" id="previous-recruitment"
                                                                    data-bs-toggle="pill"
                                                                    data-bs-target="#previous-recruitment-tab"
                                                                    type="button" role="tab"
                                                                    aria-controls="pills-previous-recruitment"
                                                                    aria-selected="false">{{ 'PreviousRecruitments' | translate }}</button>
                                                            </li>
                                                        </ul>
                                                        <div class="tab-content" id="pills-tabContent">

<!-- Current Recruitments start-->
<div class="tab-pane fade show active" id="current-recruitment-tab" role="tabpanel" aria-labelledby="current-recruitment" tabindex="0" >

    <div class="recruitment-box-area mt-3 mt-sm-4"
        *ngFor="let d of current_data | paginate: { id:'pg1', itemsPerPage: c_limit, currentPage: c_currentPage,totalItems: c_totalRecords}; let i=index;"
        [attr.data-index]="i+1">
        <div class="recruitment-count">
            <div
                class="count-box d-flex justify-content-center align-items-center screen-reader">
                <h2 class="screen-reader" *ngIf="c_currentPage==1">{{i+1}}</h2>
                <h2 class="screen-reader" *ngIf="c_currentPage>1">{{(c_limit*(c_currentPage-1)) + (i+1)}}</h2>                               
            </div>
        </div>
        <div class="recruitment-details">
            <div class="recruitment-txt">

                <h4 class="screen-reader font-adjust">{{ htmlTag(language=='English'?d.title:d.titleInHindi) }}</h4>
            </div>
            <div
                class="note-dates d-sm-flex justify-content-between align-items-center font-adjust">
                <div
                    class="d-flex align-items-center flex-wrap">

                    <div class="opening-date">
                        <strong
                            class="d-block text-green">
                            <span class="me-2 screen-reader"> <i
                                    class="bi bi-calendar3 me-1"></i>
                                {{ d.publishDate | date:
                                'MMM d, y' }}</span>
                            <span class="screen-reader"> <i
                                    class="bi bi-clock me-1"></i>
                                {{ d.publishTime |
                                timeFormat }} </span>
                        </strong> 
                        <span class="text-muted screen-reader">{{'Date & Time' | translate}}</span>
                    </div>
                    <!-- <div class="opening-date">
                        <strong class="d-block text-red screen-reader">
                            <span class="me-2"> {{ getZonename(d) }}</span>
                        </strong>
                        <div class="text-muted screen-reader">{{'Zone' | translate}}</div>
                    </div> -->
                    <div class="opening-date" *ngIf="d.category!=5">
                        <strong class="d-block text-red screen-reader">
                            <span class="me-2"> {{ categoryLanguage(d.category) }}</span>
                        </strong>
                        <div class="text-muted screen-reader">{{'Category' | translate}}
                        </div>
                    </div>
                    
                    <ng-container *ngIf="language == 'English'">
                        <div class="opening-date" *ngFor="let file of d.all_english_file_list;">
                            <strong class="d-block">
                                <a [href]="backend_url+'storage/app/uploads/'+file.filename"
                                target="_blank"
                                [download]="file.filename"
                                title="{{ htmlTag(language == 'English' ?d.title: d.titleInHindi)}}"
                                class="text-green screen-reader"><span class="me-2"> <i
                                        class="bi bi-download me-1"></i> {{ 'Download' | translate }} </span></a>
                            </strong>
                            <span class="labels text-muted screen-reader">({{ file.filesize }} ||
                                <span style="text-transform: uppercase;"[innerHtml]="file.fileicon"></span> {{ file.filetype }}) </span>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="language == 'Hindi'">
                            <ng-container  *ngIf="d.all_hindi_file_list.length > 0">
                                <div class="opening-date" *ngFor="let file of d.all_hindi_file_list;">
                                    <strong class="d-block">
                                        <a [href]="backend_url+'storage/app/uploads/'+file.filename"
                                        target="_blank"
                                        [download]="file.filename"
                                        title="{{ htmlTag(language == 'English' ?d.title: d.titleInHindi)}}"
                                        class="text-green screen-reader"><span class="me-2"> <i
                                                class="bi bi-download me-1"></i> {{ 'Download' | translate }} </span></a>
                                    </strong>
                                    <span class="labels text-muted screen-reader">({{ file.filesize }} ||
                                        <span style="text-transform: uppercase;"[innerHtml]="file.fileicon"></span> {{ file.filetype }}) </span>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="d.all_hindi_file_list.length <= 0">
                                <div class="opening-date" *ngFor="let file of d.all_english_file_list;">
                                    <strong class="d-block">
                                        <a [href]="backend_url+'storage/app/uploads/'+file.filename"
                                        target="_blank"
                                        [download]="file.filename"
                                        title="{{ htmlTag(language == 'English' ?d.title: d.titleInHindi)}}"
                                        class="text-green screen-reader"><span class="me-2"> <i
                                                class="bi bi-download me-1"></i> {{ 'Download' | translate }} </span></a>
                                    </strong>
                                    <span class="labels text-muted screen-reader">({{ file.filesize }} ||
                                        <span style="text-transform: uppercase;"[innerHtml]="file.fileicon"></span> {{ file.filetype }}) </span>
                                </div>
                            </ng-container>
                    </ng-container>
                  
                </div>

                <div class="d-flex mt-2">

<!-- <ng-container *ngIf="language == 'English'">
                        <a  *ngIf="checkFileExists(d)" [href]="backend_url+'storage/app/uploads/'+d.document"
                        target="_blank"
                        [download]="d.document"
                        title="{{ htmlTag(language == 'English' ?d.title: d.titleInHindi)}}"
                        class="btn btn-outline-success me-1 text-green screen-reader"><span class="me-2"> <i
                        class="bi bi-download me-1"></i> {{ 'Download' | translate }}</span></a>
</ng-container>
<ng-container *ngIf="language == 'Hindi'">
    <ng-container [ngSwitch]="checkFileExists_(d)">
        <ng-container *ngSwitchCase="true">
            <a  *ngIf="checkFileExists_(d)" [href]="backend_url+'storage/app/uploads/'+d.hindiDocument"
            target="_blank"
            [download]="d.hindiDocument"
            title="{{ htmlTag(language == 'English' ?d.title: d.titleInHindi)}}"
            class="btn btn-outline-success me-1 text-green screen-reader"><span class="me-2"> <i
            class="bi bi-download me-1"></i> {{ 'Download' | translate }}</span></a>
        </ng-container>
        <ng-container *ngSwitchCase="false">
            <a  *ngIf="checkFileExists(d)" [href]="backend_url+'storage/app/uploads/'+d.document"
            target="_blank"
            [download]="d.document"
            title="{{ htmlTag(language == 'English' ?d.title: d.titleInHindi)}}"
            class="btn btn-outline-success me-1 text-green screen-reader"><span class="me-2"> <i
            class="bi bi-download me-1"></i> {{ 'Download' | translate }}</span></a>
        </ng-container>
        <ng-container *ngSwitchDefault></ng-container>
      </ng-container>
</ng-container> -->

                    <a *ngIf="d.category!=5"  (click)="viewDetails(d.id,'recruitment-details',d.title,d.titleInHindi,1)" 
                        href="javascript:void(0)"
                        title="{{ htmlTag(d.title) }}"
                        class="btn btn-outline-success me-1 screen-reader">
                        <i
                            class="bi bi-hand-index-thumb"></i>
                        {{ 'ClickHere' | translate }}
                    </a>

                    <a *ngIf="d.category==5 && d.redirectURL!=null && d.redirectURL!=''"  (click)="goToExtLink(d.redirectURL)" 
                        href="javascript:void(0)"
                        title="{{ htmlTag(d.title) }}"
                        class="btn btn-outline-success me-1 screen-reader">
                        <i
                            class="bi bi-hand-index-thumb"></i>
                        {{ 'ClickHere' | translate }}
                    </a>

                </div>
            </div>
        </div>
    </div>
    <pagination-controls id="pg1" class="text-center screen-reader" (pageChange)="pageChanged($event)" *ngIf="c_totalRecords > c_limit"></pagination-controls>

                                                            </div>


                                                             <!-- Previous Recruitments start-->
        <div class="tab-pane fade" id="previous-recruitment-tab"
        role="tabpanel" aria-labelledby="previous-recruitment"
        tabindex="0">

        <div class="recruitment-box-area mt-4"
            *ngFor="let p of previous_data | paginate: { id:'pg2', itemsPerPage: p_limit, currentPage: p_currentPage,totalItems: p_totalRecords}; let x=index;"
            [attr.data-index]="x+1">
            <div class="recruitment-count">
                <div
                    class="count-box d-flex justify-content-center align-items-center screen-reader">
                    <h2> {{ x+1 }} </h2>
                </div>
            </div>
            <div class="recruitment-details">
                <div class="recruitment-txt">
                    <h4 class="screen-reader font-adjust">{{ htmlTag(language=='English'?p.title:p.titleInHindi) }}</h4>
                </div>
                <div
                    class="note-dates d-sm-flex justify-content-between align-items-center font-adjust">
                    <div
                        class="d-flex align-items-center flex-wrap flex-wrap">

                        <div class="opening-date">
                            <strong
                                class="d-block text-green">
                                <span class="me-2 screen-reader"> <i
                                        class="bi bi-calendar3 me-1"></i>
                                    {{ p.publishDate | date:
                                    'MMM d, y' }}</span>
                                <span class="screen-reader"> <i
                                        class="bi bi-clock me-1"></i>
                                    {{ p.publishTime |
                                    timeFormat }} </span>
                            </strong>
                            <span class="text-muted screen-reader">{{'Date&Time' | translate}}</span>
                        </div>
                        <div class="opening-date" *ngIf="p.category!=5">
                            <strong class="d-block text-red screen-reader">
                                <span class="me-2"> {{
                                    categoryLanguage(p.category)
                                    }}</span>
                            </strong>
                            <div class="text-muted screen-reader">{{'Category' | translate}}
                            </div>
                        </div>
    <ng-container *ngIf="language == 'English'">
        <div class="opening-date" *ngFor="let file of p.all_english_file_list;">
            <strong class="d-block">
                <a [href]="backend_url+'storage/app/uploads/'+file.filename"
                target="_blank"
                [download]="file.filename"
                title="{{ htmlTag(language == 'English' ?p.title: p.titleInHindi)}}"
                class="text-green screen-reader"><span class="me-2"> <i
                        class="bi bi-download me-1"></i> {{ 'Download' | translate }} </span></a>
            </strong>
            <span class="labels text-muted screen-reader">({{ file.filesize }} ||
                <span style="text-transform: uppercase;"[innerHtml]="file.fileicon"></span> {{ file.filetype }}) </span>
        </div>
    </ng-container>
    <ng-container *ngIf="language == 'Hindi'">
            <ng-container  *ngIf="p.all_hindi_file_list.length > 0">
                <div class="opening-date" *ngFor="let file of p.all_hindi_file_list;">
                    <strong class="d-block">
                        <a [href]="backend_url+'storage/app/uploads/'+file.filename"
                        target="_blank"
                        [download]="file.filename"
                        title="{{ htmlTag(language == 'English' ?p.title: p.titleInHindi)}}"
                        class="text-green screen-reader"><span class="me-2"> <i
                                class="bi bi-download me-1"></i> {{ 'Download' | translate }} </span></a>
                    </strong>
                    <span class="labels text-muted screen-reader">({{ file.filesize }} ||
                        <span style="text-transform: uppercase;"[innerHtml]="file.fileicon"></span> {{ file.filetype }}) </span>
                </div>
            </ng-container>
            <ng-container *ngIf="p.all_hindi_file_list.length <= 0">
                <div class="opening-date" *ngFor="let file of p.all_english_file_list;">
                    <strong class="d-block">
                        <a [href]="backend_url+'storage/app/uploads/'+file.filename"
                        target="_blank"
                        [download]="file.filename"
                        title="{{ htmlTag(language == 'English' ?p.title: p.titleInHindi)}}"
                        class="text-green screen-reader"><span class="me-2"> <i
                                class="bi bi-download me-1"></i> {{ 'Download' | translate }} </span></a>
                    </strong>
                    <span class="labels text-muted screen-reader">({{ file.filesize }} ||
                        <span style="text-transform: uppercase;"[innerHtml]="file.fileicon"></span> {{ file.filetype }}) </span>
                </div>
            </ng-container>
    </ng-container>
                        
                        
                    </div>
                    <div class="d-flex mt-2">
<!-- <ng-container *ngIf="language == 'English'">
                        <a  *ngIf="checkFileExists(p)" [href]="backend_url+'storage/app/uploads/'+p.document"
                        target="_blank"
                        [download]="p.document"
                        title="{{ htmlTag(language == 'English' ?p.title: p.titleInHindi)}}"
                        class="btn btn-outline-success me-1 text-green screen-reader"><span class="me-2"> <i
                        class="bi bi-download me-1"></i> {{ 'Download' | translate }}</span></a>
</ng-container>
<ng-container *ngIf="language == 'Hindi'">
    <ng-container [ngSwitch]="checkFileExists_(p)">
        <ng-container *ngSwitchCase="true">
            <a  *ngIf="checkFileExists_(p)" [href]="backend_url+'storage/app/uploads/'+p.hindiDocument"
            target="_blank"
            [download]="p.hindiDocument"
            title="{{ htmlTag(language == 'English' ?p.title: p.titleInHindi)}}"
            class="btn btn-outline-success me-1 text-green screen-reader"><span class="me-2"> <i
            class="bi bi-download me-1"></i> {{ 'Download' | translate }}</span></a>
        </ng-container>
        <ng-container *ngSwitchCase="false">
            <a  *ngIf="checkFileExists(p)" [href]="backend_url+'storage/app/uploads/'+p.document"
            target="_blank"
            [download]="p.document"
            title="{{ htmlTag(language == 'English' ?p.title: p.titleInHindi)}}"
            class="btn btn-outline-success me-1 text-green screen-reader"><span class="me-2"> <i
            class="bi bi-download me-1"></i> {{ 'Download' | translate }}</span></a>
        </ng-container>
        <ng-container *ngSwitchDefault></ng-container>
      </ng-container>
</ng-container> -->


                        <a *ngIf="p.category!=5"  (click)="viewDetails(p.id,'recruitment-details',p.title,p.titleInHindi,2)" 
                        href="javascript:void(0)"
                        title="{{ htmlTag(language == 'English' ?p.title: p.titleInHindi) }}"
                        class="btn btn-outline-success me-1 screen-reader">
                        <i
                            class="bi bi-hand-index-thumb"></i>
                        {{ 'ClickHere' | translate }}
                    </a>

                        <a *ngIf="p.category==5 && p.redirectURL!=null && p.redirectURL!=''"  (click)='goToExtLink(p.redirectURL)'
                            href="javascript:void(0)"
                            title="{{ htmlTag(language == 'English' ?p.title: p.titleInHindi) }}"
                            class="btn btn-outline-success mt-2 mt-xxl-0 btn-sm me-3 screen-reader">
                            <i class="bi bi-hand-index-thumb"></i>
                            {{ 'ClickHere' | translate }}
                        </a>
                       
                    </div>
                </div>
            </div>
        </div> 
        <pagination-controls id="pg2" class="text-center screen-reader" (pageChange)="p_pageChanged($event)" *ngIf="p_totalRecords > p_limit"></pagination-controls>

                                                        </div>
                                                        <!-- Previous Recruitments end-->

                                                        </div>
                                                    </div>
                                                    <!-- Recruitment section area -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- INNER CONTENT - ENDS -->
                </div>
            </div>
        </div>
    </div>

</section>

<app-clients></app-clients>

<app-footer></app-footer>